<script setup lang="ts">
// Material Symbols `credit_score` — a card with a tick, the dashboard's "Paid to
// You" glyph: money that has actually landed.
defineOptions({ inheritAttrs: false })
</script>

<template>
  <svg
    viewBox="0 -960 960 960"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      d="M160-640h640v-80H160v80Zm-80-80q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v240H160v240h164v80H160q-33 0-56.5-23.5T80-240v-480ZM598-80 428-250l56-56 114 112 226-226 56 58L598-80ZM160-720v480-180 113-413Z"
    />
  </svg>
</template>
